import React from "react";
import { Button } from "semantic-ui-react";
import useConveyorBoxHandlers from "../../../hooks/useConveyorBoxHandlers";

type Props = {};

const RelocateBoxButton = (props: Props) => {
  const { onRelocateBoxHandler } = useConveyorBoxHandlers();
  return (
    <Button
      content="Flytta låda"
      size="big"
      aria-label="Flytta låda"
      onClick={onRelocateBoxHandler}
      disabled={false}
    />
  );
};

export default RelocateBoxButton;
